import UserEdit from "./user-edit";

export default UserEdit;
